import { SidebarRailHeader } from './sidebar-rail-header'

interface FeaturedProductsHeaderProps {
  title: string
  compareAll: string
  className?: string
}

const chartIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M2 13a2 2 0 0 0 2-2V7a2 2 0 0 1 4 0v13a2 2 0 0 0 4 0V4a2 2 0 0 1 4 0v13a2 2 0 0 0 4 0v-4a2 2 0 0 1 2-2" />
  </svg>
)

export const FeaturedProductsHeader = ({ title, compareAll, className }: FeaturedProductsHeaderProps) => (
  <SidebarRailHeader
    title={title}
    icon={chartIcon}
    link={{ href: '/hearing-aids/compare', label: compareAll }}
    className={className}
  />
)
